module.exports = __webpack_public_path__ + "media/images/cellphone-6bdcfec64a6fc4f04bf1677bb4b15ed8.png";